import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import {
	LoginContainer,
	GridBackground,
	LoginPaper,
} from 'components/ApplicationStyles'
import BlockIcon from '@mui/icons-material/Block'
import HomeIcon from '@mui/icons-material/Home'
import LoginIcon from '@mui/icons-material/Login'

const Unauthorized = () => {
	const navigate = useNavigate()

	const handleGoHome = () => {
		navigate('/')
	}

	return (
		<LoginContainer maxWidth={false}>
			<GridBackground />
			<LoginPaper elevation={0}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						textAlign: 'center',
						gap: 3,
					}}
				>
					{/* 아이콘 */}
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							width: 100,
							height: 100,
							borderRadius: '50%',
							background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
							boxShadow: '0 8px 25px rgba(255, 107, 107, 0.3)',
						}}
					>
						<BlockIcon
							sx={{
								fontSize: 50,
								color: '#fff',
							}}
						/>
					</Box>

					{/* 제목 */}
					<Typography
						variant="h3"
						sx={{
							color: '#fff',
							fontWeight: 'bold',
							textShadow: '0 2px 10px rgba(0, 0, 0, 0.3)',
						}}
					>
						403
					</Typography>

					{/* 부제목 */}
					<Typography
						variant="h5"
						sx={{
							color: 'rgba(255, 255, 255, 0.9)',
							fontWeight: '500',
							mb: 1,
						}}
					>
						접근 권한이 없습니다
					</Typography>

					{/* 설명 */}
					<Typography
						variant="body1"
						sx={{
							color: 'rgba(255, 255, 255, 0.7)',
							lineHeight: 1.6,
							maxWidth: 300,
						}}
					>
						이 페이지에 접근할 수 있는 권한이 없습니다.
						<br />
						로그인 후 다시 시도해주세요.
					</Typography>

					{/* 버튼들 */}
					<Box
						sx={{
							display: 'flex',
							gap: 2,
							mt: 2,
						}}
					>
						<Button
							variant="outlined"
							onClick={handleGoHome}
							startIcon={<HomeIcon />}
							sx={{
								borderColor: 'rgba(255, 255, 255, 0.3)',
								color: 'rgba(255, 255, 255, 0.9)',
								py: 1.5,
								px: 3,
								borderRadius: '12px',
								textTransform: 'none',
								fontWeight: '600',
								'&:hover': {
									borderColor: 'rgba(255, 255, 255, 0.5)',
									backgroundColor: 'rgba(255, 255, 255, 0.1)',
								},
							}}
						>
							홈으로 가기
						</Button>
					</Box>

					{/* 추가 정보 */}
					<Typography
						variant="caption"
						sx={{
							color: 'rgba(255, 255, 255, 0.5)',
							textAlign: 'center',
							mt: 2,
						}}
					>
						© 2025 MindCline. All rights reserved.
					</Typography>
				</Box>
			</LoginPaper>
		</LoginContainer>
	)
}

export default Unauthorized
